export default __webpack_public_path__ + "static/media/abu-dhabi-airport-free-zone.c09478a1.png";